// extracted by mini-css-extract-plugin
export default {"write":"InquiryUpdate_write__0NFdd","selectStarRegist":"InquiryUpdate_selectStarRegist__hBKOg"};